import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import CertificateHistoryService from "../service/certificateHistory";
import HttpClient from "../network/http";
import { fetchCsrfToken, useAuthContext } from "../context/AuthContext";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function useCertificateHistory(conditions) {
  //location.path로 학교 아이디, role은 파람으로 모든 정보 가져오기
  const queryClient = useQueryClient();
  const { address } = useAuthContext();
  const httpClient = new HttpClient(baseURL, () => fetchCsrfToken(), address);
  const certificateHistoryService = new CertificateHistoryService(httpClient);

  const certificateHistoryQuery = useQuery(
    ["certificateHistory", conditions || ""],
    () =>
      certificateHistoryService.findAllCertificateHistoryWithRegiInfoBySchoolid(
        conditions
      ),
    {
      // onSuccess: (success) => {
      //   console.log("success", success);
      // },
      enabled: !!conditions?.schoolid,
      staleTime: 1000 * 60 * 2, //2분,
    }
  );

  const updateCertificateHistory = useMutation(
    (certificateHistory) =>
      certificateHistoryService.updateCertificateHistory(certificateHistory),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["certificateHistory"]);
      },
      onError: (error) => {
        // Handle the failure by displaying an error message or performing other actions
        console.error("Error updating certificateHistory:", error);
        alert(error);
        // Add your error handling logic here
      },
    }
  );

  const createCertificateHistory = useMutation(
    (certificateHistory) =>
      certificateHistoryService.createCertificateHistory(certificateHistory),
    {
      onSuccess: () => queryClient.invalidateQueries(["certificateHistory"]),
      onError: (error) => {
        console.error("Error creating:", error);
      },
    }
  );

  const deleteCertificateHistory = useMutation(
    (id) => certificateHistoryService.deleteCertificateHistory(id),
    {
      onSuccess: () => {
        // Refetch the query first
        queryClient.invalidateQueries(["certificateHistory"]);
      },
    }
  );

  return {
    certificateHistoryQuery,
    updateCertificateHistory,
    createCertificateHistory,
    deleteCertificateHistory,
  };
}
